import { render, staticRenderFns } from "./GoingOfflineDialog.vue?vue&type=template&id=521d9016&scoped=true"
import script from "./GoingOfflineDialog.vue?vue&type=script&lang=js"
export * from "./GoingOfflineDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d9016",
  null
  
)

export default component.exports